import { createSelector } from "reselect";

const dailyMessageLimitSelector = (state: TReduxState) =>
  state.features.dailyMessageLimit;

export const hasLimitReached = createSelector(
  dailyMessageLimitSelector,
  (dailyMessageLimit) => dailyMessageLimit.hasLimitReached
);
